'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'CONTACT',
    link: '/contact'
  }, {
    text: 'LOGIN',
    link: ''
  }],
  loginLink: {
    text: 'LOGIN',
    src: ''
  },
  siteLinks: [{
    title: {
      text: 'PRODUCTS'
    },
    list: [{
      text: 'Expense',
      src: '/expense-management'
    }, {
      text: 'Intelligence',
      src: '/business-intelligence'
    }]
  }, {
    title: {
      text: 'FEATURES'
    },
    list: [{
      text: 'Mobile App',
      src: '/mobile'
    }, {
      text: 'Compliance',
      src: '/compliance'
    }, {
      text: 'Software Integration',
      src: '/financial-connectors'
    }]
  }, {
    title: {
      text: 'ABOUT US'
    },
    list: [{
      text: 'Platform',
      src: '/concur-integrated-ecosystem'
    }, {
      text: 'Why Concur',
      src: '/why-concur'
    }, {
      text: 'Office Locations',
      src: '/contact/offices'
    }, {
      text: 'Contact Sales',
      src: '/contact',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'RESOURCES'
    },
    list: [{
      text: 'Resource Center',
      src: '/resource-center'
    }, {
      text: 'Case Studies',
      src: '/casestudy'
    }, {
      text: 'Privacy Policy',
      src: '/privacy-policy'
    }]
  }],
  supportLinks: [{
    text: 'CONCUR BLOG',
    href: ''
  }, {
    text: 'CONTACT',
    href: '/contact'
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};